// TODO: Update file name once whole project imports the new component
import { FC, forwardRef } from 'react';

import { CSSProperties } from 'styled-components';
import { useThemeContext } from '../../../global-state/themeContext';
import { Colors } from '../../../theme';
import { Spacing } from '../../../utils';
import { StyledContainer } from './ContainerV2.styles';

export type FlexDirections = 'row' | 'rowReverse' | 'column' | 'columnReverse';
export type JustifyContent = 'center' | 'start' | 'end' | 'between' | 'around' | 'evenly';
export type Align = 'center' | 'start' | 'end' | 'stretch' | 'baseline';
export type Wrap = 'wrap' | 'nowrap' | 'wrapReverse';
export type Position = 'absolute' | 'fixed' | 'relative' | 'static' | 'sticky';
export type Cursor = 'pointer' | 'default' | 'none' | 'notAllowed';
export type TextAlign = 'center' | 'left' | 'right' | 'justify';
export type OverFlow = 'hidden' | 'auto' | 'scroll' | 'visible';
export type Role =
  | 'button'
  | 'link'
  | 'menuitem'
  | 'listitem'
  | 'list'
  | 'listbox'
  | 'option'
  | 'presentation'
  | 'radio'
  | 'radiogroup'
  | 'separator'
  | 'tab'
  | 'tabpanel'
  | 'textbox'
  | 'tree'
  | 'treeitem';

export type StyledContainerProps = {
  padding?: Spacing;
  margin?: Spacing;
  width?: string | Spacing;
  height?: string | Spacing;
  maxWidth?: string | Spacing;
  minWidth?: string | Spacing;
  maxHeight?: string | Spacing;
  minHeight?: string | Spacing;
  display?: string;
  flexDirection?: FlexDirections;
  justifyContent?: JustifyContent;
  gap?: Spacing;
  alignItems?: Align;
  alignSelf?: Align;
  flexWrap?: Wrap;
  flex?: number;
  backgroundColor?: Colors;
  borderColor?: Colors;
  hasBorder?: boolean;
  position?: Position;
  top?: string;
  left?: string;
  right?: string;
  bottom?: string;
  overflow?: OverFlow;
  cursor?: Cursor;
  opacity?: number;
  textAlign?: TextAlign;
  alignContent?: Align;
  borderRadius?: Spacing;
  shadow?: boolean;
};

export type ContainerProps = StyledContainerProps & {
  role?: Role;
  style?: CSSProperties;
  onClick?: () => void;
};

export const ContainerV2 = forwardRef<HTMLDivElement, React.PropsWithChildren<ContainerProps>>(
  ({ children, ...props }, ref) => {
    return (
      <StyledContainer ref={ref} data-testid="container-wrapper" {...props}>
        {children}
      </StyledContainer>
    );
  },
);

export const RowFlexContainer = forwardRef<HTMLDivElement, React.PropsWithChildren<ContainerProps>>(
  ({ children, ...props }, ref) => (
    <ContainerV2 ref={ref} display="flex" flexDirection="row" {...props}>
      {children}
    </ContainerV2>
  ),
);

export const ColumnFlexContainer = forwardRef<HTMLDivElement, React.PropsWithChildren<ContainerProps>>(
  ({ children, ...props }, ref) => (
    <ContainerV2 ref={ref} display="flex" flexDirection="column" {...props}>
      {children}
    </ContainerV2>
  ),
);

export const Divider: FC<React.PropsWithChildren<StyledContainerProps>> = (props) => {
  const { mode } = useThemeContext();
  const isDarkMode = mode === 'dark';
  return (
    <ContainerV2
      height="1px"
      width="100%"
      backgroundColor={isDarkMode ? 'borderGrayDark' : 'borderGray'}
      {...props}
    />
  );
};
